import { amplifyErrors, BaseError } from './customError';
import { confirmSignIn, fetchAuthSession, getCurrentUser, signIn, signOut } from 'aws-amplify/auth';

import { Amplify } from 'aws-amplify';
import { CUSTOM_WITHOUT_SRP } from '../constants/amplify';
import { ErrorName } from '../type/enums';

export interface UserSignInData {
    username: string;
    // captchaToken: string; NOTE: Temporarily disabling reCAPTCHA.
}
interface HandleCurrentSessionOptions {
    forceRefresh?: boolean;
}

export const initAmplify = (userPoolId, userPoolClientId): void => {
    Amplify.configure({
        Auth: {
            Cognito: {
                userPoolClientId,
                userPoolId,
                loginWith: {
                    oauth: {
                        domain: 'qa',
                        scopes: ['openid', 'email', 'profile', 'aws.cognito.signin.user.admin'],
                        responseType: 'code',
                    },
                    username: false,
                    email: true,
                    password: false,
                },
            },
        },
    });
};

export const handleSignIn = async ({ username }: UserSignInData): Promise<any> => {
    try {
        username = username.toLowerCase()
        await handleSignOut()
        const result = await signIn({
            username,
            options: {
                authFlowType: CUSTOM_WITHOUT_SRP,
            },
        });
        return result;
    } catch (err) {
        throw err;
    }
};
export const handleConfirmSignIn = async (challengeResponse: string): Promise<any> => {
    try {
        const { isSignedIn, nextStep } = await confirmSignIn({ challengeResponse });
        if (!isSignedIn) {
            throw new BaseError(amplifyErrors[ErrorName.INCORRECT_CODE], ErrorName.INCORRECT_CODE);
        }
        return nextStep;
    } catch (err) {
        throw new BaseError(amplifyErrors[err.name], err.name);
    }
};



export const handleCurrentSession = async ({ forceRefresh = false }: HandleCurrentSessionOptions = {}): Promise<{ accessToken: string, idToken: string }> => {
    try {
        const { accessToken, idToken } = (await fetchAuthSession({ forceRefresh })).tokens ?? {};
        if (!accessToken || !idToken) {
            throw new BaseError(amplifyErrors[ErrorName.NO_SESSION], ErrorName.NO_SESSION); 
        }
        return {
            accessToken: accessToken.toString(),
            idToken: idToken.toString(),
        };
    } catch (err) {
        console.error(err);
        throw new BaseError(amplifyErrors[ErrorName.NO_SESSION], ErrorName.NO_SESSION); 
    }
};

export const getCurrentAuthenticatedUser = async (): Promise<void> => {
    try {
        const { username, userId, signInDetails } = await getCurrentUser();
        console.log(`The username: ${username}`);
        console.log(`The userId: ${userId}`);
        console.log(`The signInDetails: ${JSON.stringify(signInDetails, null, 2)}`);
    } catch (err) {
        console.error(err);
        throw err;
    }
};

export const handleSignOut = async (): Promise<void> => {
    try {
        await signOut();
    } catch (error) {
        console.error('error signing out: ', error);
        throw error;
    }
};

export const renewUserAuthentication = async ({ username }: UserSignInData): Promise<void> => {
    try {
        await handleSignOut();
        await handleSignIn({ username });
    } catch (error) {
        console.error('error reassigning user: ', error);
        throw error;
    }
};
